/*
 * <pagination-jump> – page number input in snippets/pagination.liquid: Enter jumps to that page
 * (full navigation, starts at the top); an invalid number resets to the current page.
 */
if (!customElements.get("pagination-jump")) {
  customElements.define(
    "pagination-jump",
    class PaginationJump extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector("input");
        this.onKeydown = (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            this.go();
          }
        };
        this.input?.addEventListener("keydown", this.onKeydown);
      }

      disconnectedCallback() {
        this.input?.removeEventListener("keydown", this.onKeydown);
      }

      go() {
        const page = parseInt(this.input.value, 10);
        const maxPages = parseInt(this.input.getAttribute("max"), 10);
        const currentPage = parseInt(this.input.getAttribute("value"), 10);

        if (page >= 1 && page <= maxPages && page !== currentPage) {
          if ("scrollRestoration" in history) history.scrollRestoration = "manual";
          window.scrollTo(0, 0);
          const url = new URL(location.href);
          url.searchParams.set("page", page);
          location.href = url.toString();
        } else {
          this.input.value = currentPage;
        }
      }
    }
  );
}
